import store from "@/store";
import {validateFileMd5, validatePublicFileMd5} from '@/service/api.js';
import {getToken} from '@/library/js/auth'


/**
 *生产随机id
 */
var uuid = function uuid () {
    var s = [];
    var hexDigits = "0123456789abcdefghijklmnopqrstuvwxyz";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23];
    return s.join("");
};

var uploader;

/**
 *通用获取阿里云签名 sshu 2018-04-11
 */
function Upload (fileFrom) {
    var path = "aliba/iemaker/" + fileFrom + getDateForPath();

    Object.defineProperty(this, "path", {
        get: function () {
            return path;
        },
        set: function (value) {
            path = value;
        }
    });

    let accessid = '';// id
    // let accesskey = '';// 秘钥
    let host = '';// host: 指的是用户要往哪个域名发往上传请求   host+文件名就是下载路径了.
    let policyBase64 = '';// policy：指的是用户表单上传的策略policy，是经过base64编码过的字符串
    let signature = '';// signature：是对上述第三个变量policy签名后的字符串
    let callbackbody = '';// 返回的body
    // let filename = '';// 文件的名字.
    let key = '';// 过期时间
    let expire = 0;// 文件名字
    // let g_object_name = '';// 文件类型. local_name
    // let g_object_name_type = 'random_name';
    let timestamp;
    let now = timestamp = Date.parse(new Date()) / 1000;

    function send_request () {
        let xmlhttp = null;
        if (window.XMLHttpRequest) {
            xmlhttp = new XMLHttpRequest();
        }
        else if (window.ActiveXObject) {
            xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
        }

        if (xmlhttp != null) {
            let path = "aliba/" + fileFrom + getDateForPath();
            const token = ssoClient.getCookie() || getToken();
            let serverUrl = process.env.VUE_APP_APIURL + '/common/oss/signature?path=' + path + '&token=' + token;
            xmlhttp.open("GET", serverUrl, false);
            xmlhttp.send(null);
            return xmlhttp.responseText;
        }
        else {
            Message.error('您的浏览器不支持XMLHTTP,请换浏览器登录再使用');
        }
    };

    function get_signature () {
        // 可以判断当前expire是否超过了当前时间,如果超过了当前时间,就重新取一下.3s 做为缓冲
        now = timestamp = Date.parse(new Date()) / 1000;
        if (expire < now + 3) {
            callbackbody = send_request()
            var obj = eval("(" + callbackbody + ")").data;
            host = obj['host']
            policyBase64 = obj['policy']
            accessid = obj['accessid']
            signature = obj['signature']
            expire = parseInt(obj['expire'])
            key = obj['dir']
            return true;
        }
        return false;
    };

    /**
     *获取阿里签证
     */
    this.getFormData = function () {
        get_signature();

        var fdata = [];
        fdata.accessid = accessid;
        fdata.dir = key;
        fdata.expire = expire;
        fdata.host = host;
        fdata.policy = policyBase64;
        fdata.signature = signature;

        return fdata;
    };

    /**
     *根据当前时间当前用户的学校id和用户id拼接文件夹路径
     */
    function getDateForPath () {
        let date = new Date();
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;

        if (store.getters.schoolId !== "") {
            // 当用户学校id不为空时
            return "/" + y + "/" + m + "/" + d + "/" + store.getters.schoolId + "/" + store.getters.userId + "/";
        } else {
            // 当用户学校id为空时
            return "/" + y + "/" + m + "/" + d + "/0000000000000000/" + store.getters.userId + "/";
        }
    }
}

/**
 *定义上传方法
 * fileForm:来源
 * fileExtStr：允许上传的文件类型
 * myFileCount：允许上传的文件个数
 * singleFileSize：单个文件的大小
 * isMd5 是否需要计算文件MD5 true :需要  false：不需要
 * testBack 回调函数
 */

function WebUploadInit (fileForm, fileExtStr, myFileCount, singleFileSize, isMd5, testBack, isPublic = false) {
    // 定义获取阿里签名对象，并且将签名信息保存到aliSigndata
    // var userType = getCookie('userType'); //0 注册 1教师 2学生
    var upload = new Upload(fileForm);

    let fileMd5Arr = [];// 记录上传文件的MD5
    let hasFileMd5Arr = [];// 查找出重复的MD5

    var aliSigndata = upload.getFormData();

    if (myFileCount === "" || myFileCount == null) {
        myFileCount = 10;
    }

    var fileSizeLimit = singleFileSize * myFileCount * 1024 * 1024;
    var fileSingleSizeLimit = singleFileSize * 1024 * 1024;
    var totalFileSize = singleFileSize * myFileCount;

    // 定义文件数组
    var doc_arry = [];

    jQuery(function () {
        var $ = jQuery, // just in case. Make sure it's not an other libaray.
            $wrap = $('#uploader'),
            // 文件容器
            $queue = $('<ul class="filelist"></ul>').appendTo($wrap.find('.queueList')),
            // 状态栏，包括进度和控制按钮
            $statusBar = $wrap.find('.statusBar'),
            // 文件总体选择信息。
            $info = $statusBar.find('.info'),
            // 上传按钮
            $upload = $wrap.find('.uploadBtn'),
            // 没选择文件之前的内容。
            $placeHolder = $wrap.find('.placeholder'),
            // 总体进度条
            $progress = $statusBar.find('.progress').hide(),
            // 添加的文件数量
            fileCount = 0,
            // 添加的文件总大小
            fileSize = 0,
            // 优化retina, 在retina下这个值是2
            ratio = window.devicePixelRatio || 1,
            // 缩略图大小
            thumbnailWidth = 110 * ratio,
            thumbnailHeight = 110 * ratio,
            // 可能有pedding, ready, uploading, confirm, done.
            state = 'pedding',
            // 所有文件的进度信息，key为file id
            percentages = {},
            supportTransition = (function () {
                var s = document.createElement('p').style,
                    r = 'transition' in s ||
                        'WebkitTransition' in s ||
                        'MozTransition' in s ||
                        'msTransition' in s ||
                        'OTransition' in s;
                s = null;
                return r;
            })();
        // WebUploader实例
        // uploader;
        // 删除上传按钮的点击事件
        $upload.unbind();
        if (!WebUploader.Uploader.support()) {
            alert('Web Uploader 不支持您的浏览器！如果您使用的是IE浏览器，请尝试升级 flash 播放器');
            throw new Error('WebUploader does not support the browser you are using.');
        }
        // 实例化
        uploader = WebUploader.create({
            pick: {
                id: '#filePicker',
                label: '点击选择文件'
            },
            dnd: '#uploader .queueList',
            paste: document.body,
            swf: "/static/lib/webuploader/Uploader.swf",
            disableGlobalDnd: true,
            chunked: false,
            server: aliSigndata.host,
            fileNumLimit: myFileCount,
            fileSizeLimit: fileSizeLimit,
            fileSingleSizeLimit: fileSingleSizeLimit,
            formData: {
                'OSSAccessKeyId': aliSigndata.accessid,
                'policy': aliSigndata.policy,
                'signature': aliSigndata.signature,
                'key': aliSigndata.dir,
                'Content-Disposition': ''
            },
            accept: {
                extensions: fileExtStr
            }
        });
        // 添加“添加文件”的按钮，
        uploader.addButton({
            id: '#filePicker2',
            label: '继续添加'
        });

        // 当有文件添加进来时执行，负责view的创建
        function addFile (file) {
            var html = '';
            //当前用户为教师时才有共享和转换的功能
            // if(userType == 1 && fileForm == "material") {
            // 	html = '<div class="oper-panel"><div class="share">' +
            // 		'<span class="noshare"></span>共享</div>',
            // 		ext = file.ext.toLowerCase();
            // 	//当文件为ppt或pptx是才需要转换为h5
            // 	if(ext == 'ppt' || ext == 'pptx') {
            // 		html += '<div class="h5"><span class="noh5"></span>动画</div>';
            // 	}
            //
            // 	html += '</div>';
            // }

            var $li = $('<li id="' + file.id + '"><div class="content">' + html +
                '<p class="imgWrap"></p>' +
                '<p class="progress"><span></span></p>' +
                '</div>' +
                '<p class="title" title="' + file.name + '">' + file.name + '</p>' +
                '</li>'),
                $btns = $('<div class="file-panel">' +
                    '<span class="cancel">删除</span>' +
                    '<span class="rotateRight">向右旋转</span>' +
                    '<span class="rotateLeft">向左旋转</span></div>').appendTo($li),
                $prgress = $li.find('p.progress span'),
                $wrap = $li.find('p.imgWrap'),
                $info = $('<p class="error"></p>'),
                showError = function (code) {
                    switch (code) {
                        case 'exceed_size':
                            text = '文件大小超出';
                            break;
                        case 'interrupt':
                            text = '上传暂停';
                            break;
                        default:
                            text = '上传失败，请重试';
                            break;
                    }
                    $info.text(text).appendTo($li);
                };
            if (file.getStatus() === 'invalid') {
                showError(file.statusText);
            } else {
                $wrap.text('预览中');
                uploader.makeThumb(file, function (error, src) {
                    if (error) {
                        //						$wrap.text('不能预览');
                        //						return;
                        var imgPrefixUrl = store.getters.defalutImgPath;
                        var img = $('<img src="' + imgPrefixUrl + '" />');
                        $wrap.empty().append(img);

                    } else {
                        var img = $('<img src="' + src + '" />');
                        $wrap.empty().append(img);
                    }
                }, thumbnailWidth, thumbnailHeight);
                percentages[file.id] = [file.size, 0];
                file.rotation = 0;
            }
            file.on('statuschange', function (cur, prev) {
                if (prev === 'progress') {
                    $prgress.hide().width(0);
                } else if (prev === 'queued') {
                    $li.off('mouseenter mouseleave');
                    $btns.remove();
                }
                if (cur === 'error' || cur === 'invalid') {
                    showError(file.statusText);
                    percentages[file.id][1] = 1;
                } else if (cur === 'interrupt') {
                    showError('interrupt');
                } else if (cur === 'queued') {
                    percentages[file.id][1] = 0;
                } else if (cur === 'progress') {
                    $info.remove();
                    $prgress.css('display', 'block');
                } else if (cur === 'complete') {
                    $li.append('<span class="success"></span>');
                }
                $li.removeClass('state-' + prev).addClass('state-' + cur);
            });
            $li.on('mouseenter', function () {
                $btns.stop().animate({
                    height: 30
                });
            });
            $li.on('mouseleave', function () {
                $btns.stop().animate({
                    height: 0
                });
            });
            $btns.on('click', 'span', function () {
                var index = $(this).index(),
                    deg;
                switch (index) {
                    case 0:
                        uploader.removeFile(file, true);
                        return;
                    case 1:
                        file.rotation += 90;
                        break;
                    case 2:
                        file.rotation -= 90;
                        break;
                }
                if (supportTransition) {
                    deg = 'rotate(' + file.rotation + 'deg)';
                    $wrap.css({
                        '-webkit-transform': deg,
                        '-mos-transform': deg,
                        '-o-transform': deg,
                        'transform': deg
                    });
                } else {
                    $wrap.css('filter', 'progid:DXImageTransform.Microsoft.BasicImage(rotation=' + (~~((file.rotation / 90) % 4 + 4) % 4) + ')');
                }
            });

            $(".share").on('click', 'span', function () {
                if ($(this).hasClass('isshare')) {
                    $(this).removeClass('isshare');
                    $(this).addClass("noshare");
                } else {
                    $(this).removeClass('noshare');
                    $(this).addClass("isshare");
                }
            });

            $(".h5").on('click', 'span', function () {
                if ($(this).hasClass('ish5')) {
                    $(this).removeClass('ish5');
                    $(this).addClass("noh5");
                } else {
                    $(this).removeClass('noh5');
                    $(this).addClass("ish5");
                }
            });

            $li.appendTo($queue);

            $(".share span").click(function () {
                if ($(this).hasClass('isshare')) {
                    $(this).removeClass('isshare');
                    $(this).addClass("noshare");
                } else {
                    $(this).removeClass('noshare');
                    $(this).addClass("isshare");
                }
            });

            $(".h5 span").click(function () {
                if ($(this).hasClass('ish5')) {
                    $(this).removeClass('ish5');
                    $(this).addClass("noh5");
                } else {
                    $(this).removeClass('noh5');
                    $(this).addClass("ish5");
                }
            });
        }

        // 移除文件
        function removeFile (file) {
            var $li = $('#' + file.id);
            delete percentages[file.id];
            updateTotalProgress();
            $li.off().find('.file-panel').off().end().remove();
        }

        // 更新上传进度
        function updateTotalProgress () {
            var loaded = 0,
                total = 0,
                spans = $progress.children(),
                percent;
            $.each(percentages, function (k, v) {
                total += v[0];
                loaded += v[0] * v[1];
            });
            percent = total ? loaded / total : 0;
            spans.eq(0).text(Math.round(percent * 100) + '%');
            spans.eq(1).css('width', Math.round(percent * 100) + '%');
            updateStatus();
        }

        // 更新文件状态，个数
        function updateStatus () {
            var text = '',
                stats;
            if (state === 'ready') {
                text = '选中' + fileCount + '个文件，共' +
                    WebUploader.formatSize(fileSize) + '。';
            } else if (state === 'confirm') {
                stats = uploader.getStats();
                if (stats.uploadFailNum) {
                    text = '已成功上传' + stats.successNum + '份文件，' +
                        stats.uploadFailNum + '份文件上传失败，<a class="retry" href="#">重新上传</a>失败文件或<a class="ignore" href="#">忽略</a>'
                }

            } else {
                stats = uploader.getStats();
                text = '共' + fileCount + '个（' +
                    WebUploader.formatSize(fileSize) +
                    '），已上传' + stats.successNum + '个';
                if (stats.uploadFailNum) {
                    text += '，失败' + stats.uploadFailNum + '个';
                }
            }
            $info.html(text);
        }

        // 查询文件MD5值是否已存在
        function validatemd5 () {
            let md5Arr = [];
            // if(fileMd5Arr.length>0){
            for (let i = 0; i < fileMd5Arr.length; i++) {
                md5Arr.push(fileMd5Arr[i].md5);
            }
            let params = {
                md5List: JSON.stringify(md5Arr)
            };
            if (isPublic) {
                return validatePublicFileMd5(params).then(function (result) {
                        if (result && parseInt(result.code) === 1) {
                            md5ResultFile(result.data);
                        }
                    }
                ).catch(function (error) {
                    console.log(error);
                    Message.error('请求出现异常');
                });
            } else {
                return validateFileMd5(params).then(function (result) {
                        if (result && parseInt(result.code) === 1) {
                            md5ResultFile(result.data);
                        }
                    }
                ).catch(function (error) {
                    console.log(error);
                    Message.error('请求出现异常');
                });
            }
        }

        // 处理查询文件MD5值是否已存在的结果
        function md5ResultFile (data) {
            hasFileMd5Arr = data;
            if (hasFileMd5Arr.length >= 1) {
                //获取重复MD5的数组
                let doubleFileMd5 = [];
                for (let i = 0; i < fileMd5Arr.length; i++) {
                    let isHave = hasFileMd5Arr.findIndex(item => item === fileMd5Arr[i].md5);
                    if (isHave >= 0) {
                        doubleFileMd5.push(fileMd5Arr[i]);
                    }
                }
                //获取所有待上传文件
                var fileArr = uploader.getFiles();

                for (let i = 0; i < fileArr.length; i++) {
                    let curFileMd5 = doubleFileMd5.filter((item) => {
                        return fileArr[i].id === item.id;
                    })[0];

                    if (curFileMd5 != null) {
                        uploader.skipFile(fileArr[i]);

                        var $li = $('#' + fileArr[i].id), $percent = $li.find('.progress span');
                        $percent.css('display', 'block');
                        $percent.css('width', 1 * 100 + '%');

                        var doc = {
                            folderId: 0,
                            title: fileArr[i].name.substring(0, fileArr[i].name.lastIndexOf('.')).replace('', ''),
                            origName: fileArr[i].name,
                            fileUrl: '',
                            fileSize: fileArr[i].size,
                            fileExt: fileArr[i].ext,
                            fileType: fileArr[i].type,
                            fileMd5Str: curFileMd5.md5
                        };

                        doc_arry.push(doc);
                    }
                }
            }
        }

        // 设置文件的状态
        function setState (val) {
            var stats;
            if (val === state) return;
            $upload.removeClass('state-' + state);
            $upload.addClass('state-' + val);
            state = val;
            switch (state) {
                case 'pedding':
                    $placeHolder.removeClass('element-invisible');
                    $queue.parent().removeClass('filled');
                    $queue.find("li").remove();
                    $queue.hide();
                    $statusBar.addClass('element-invisible');
                    uploader.refresh();
                    break;
                case 'ready':
                    $placeHolder.addClass('element-invisible');
                    $('#filePicker2').removeClass('element-invisible');
                    $queue.parent().addClass('filled');
                    $queue.show();
                    $statusBar.removeClass('element-invisible');
                    uploader.refresh();
                    break;
                case 'uploading':
                    $('#filePicker2').addClass('element-invisible');
                    $progress.show();
                    $upload.hide();
                    // $upload.text('暂停上传');
                    break;
                case 'paused':
                    $progress.show();
                    $upload.text('继续上传');
                    break;
                case 'confirm':
                    $progress.hide();
                    $upload.text('开始上传').addClass('disabled');
                    stats = uploader.getStats();
                    if (stats.successNum && !stats.uploadFailNum) {
                        setState('finish');
                        return;
                    }
                    break;
                case 'finish':
                    stats = uploader.getStats();
                    if (stats.successNum) {
                        if (testBack !== "" && testBack !== undefined && $.isFunction(testBack)) {
                            // 上传成功后，重置队列，解决不刷新页面 上传重复文件提示 文件已在上传队列中的提示
                            uploader.reset();
                            $queue.remove();
                            testBack(doc_arry);
                        }
                    } else {
                        state = 'done';
                    }
                    break;
            }
            updateStatus();
        }

        // 监听上传进度方法
        uploader.onUploadProgress = function (file, percentage) {
            var $li = $('#' + file.id),
                $percent = $li.find('.progress span');
            $percent.css('width', percentage * 100 + '%');
            percentages[file.id][1] = percentage;
            updateTotalProgress();
        };

        // 监听文件进入上传队列方法
        uploader.onFileQueued = function (file) {
            if (isMd5) {
                // 计算文件的MD5
                uploader.md5File(file).then(function (ret) {
                    $('.ivu-spin').css('display', 'block');
                    var fileObj = {};
                    fileObj.id = file.id;
                    fileObj.md5 = ret;
                    fileMd5Arr.push(fileObj);
                });
            }

            fileCount++;
            fileSize += file.size;
            if (fileCount === 1) {
                $placeHolder.addClass('element-invisible');
                $statusBar.show();
            }

            addFile(file);
            setState('ready');
            updateTotalProgress();

        };
        // 监听文件从队列中移除方法
        uploader.onFileDequeued = function (file) {
            fileCount--;
            fileSize -= file.size;
            if (!fileCount) {
                setState('pedding');
            }
            removeFile(file);
            updateTotalProgress();

            if (isMd5) {
                //从MD5数组中删除移除的文件的MD5
                fileMd5Arr.splice(fileMd5Arr.findIndex(item => item.id === file.id), 1)
            }

        };
        // 监听文件上传之前方法
        uploader.onUploadBeforeSend = function (object, data, headers) {
            var guid = uuid();
            data.key = data.key + guid + '/f.' + object.file.ext;
            data['Content-Disposition'] = 'attachment;filename=' + encodeURI(object.file.name);
            object.file.url = data.key;
        };
        // 监听文件上传成功方法
        uploader.onUploadSuccess = function (file, response) {
            let curFileMd5 = '';
            if (isMd5) {
                let curFile = fileMd5Arr.filter((item) => {
                    return file.id === item.id;
                })[0];
                if (curFile != null) {
                    curFileMd5 = curFile.md5;
                }
            }

            //*************************************胡珊珊 屏蔽于2019-04-29 解决同时上传相同文件名不同文件内容 只上传成功一个的问题 开始*************************************
            // var isHaveFile = false;
            // for (var i = 0; i < doc_arry.length; i++) {
            //   if (doc_arry[i].origName === file.name) {
            //     doc_arry[i].fileUrl = file.url;
            //     doc_arry[i].fileMd5Str = curFileMd5;
            //
            //     isHaveFile = true;
            //   }
            // }
            //
            // if (!isHaveFile) {
            //   var doc = {
            //     folderId: 0,
            //     title: file.name.substring(0, file.name.lastIndexOf('.')).replace('', ''),
            //     origName: file.name,
            //     fileUrl: file.url,
            //     fileSize: file.size,
            //     fileExt: file.ext,
            //     fileType: file.type,
            //     fileMd5Str: curFileMd5
            //   };
            //   doc_arry.push(doc);
            // }

            //*************************************胡珊珊 屏蔽于2019-04-29 解决同时上传相同文件名不同文件内容 只上传成功一个的问题 结束*************************************

            var doc = {
                folderId: 0,
                title: file.name.substring(0, file.name.lastIndexOf('.')).replace('', ''),
                origName: file.name,
                fileUrl: file.url,
                fileSize: file.size,
                fileExt: file.ext,
                fileType: file.type,
                fileMd5Str: curFileMd5
            };
            doc_arry.push(doc);
        };
        // 监听文件的所有状态
        uploader.on('all', function (type) {
            switch (type) {
                case 'uploadFinished':
                    setState('confirm');
                    break;
                case 'startUpload':
                    setState('uploading');
                    break;
                case 'stopUpload':
                    setState('paused');
                    break;
            }
        });
        // 监听文件出错
        uploader.onError = function (code) {
            if (code === "F_EXCEED_SIZE") {
                Message.error('操作失败，文件大小超出，单个文件最大 ' + singleFileSize + 'MB');
            } else if (code === "F_FXCEED_SIZE") {
                Message.error('操作失败，文件总大小超出 ' + totalFileSize + 'MB');
            } else if (code === 'Q_TYPE_DENIED') {
                Message.error('操作失败，文件格式不支持');
            } else if (code === 'F_DUPLICATE') {
                Message.error('操作失败，文件已在上传列表');
            } else if (code === 'Q_EXCEED_NUM_LIMIT') {
                Message.error('操作失败，文件个数超出限制，只能上传' + myFileCount + '个文件');
            } else if (code === 'Q_EXCEED_SIZE_LIMIT') {
                Message.error('操作失败，文件大小超出，单个文件最大' + singleFileSize + 'MB');
            } else {
                Message.error('操作失败，错误代码：' + code);
            }
        };
        // 点击上传按钮
        $upload.on('click', function () {
            if ($upload.hasClass('validate-fail')) {
                Message.error('请选择类型');
                return;
            }
            // 判断是否需要计算文件MD5
            if (isMd5) {
                // 当开始上传流程时将该批次上传的文件MD5值去数据库查询
                validatemd5().then(function () {
                    if ($(this).hasClass('disabled')) {
                        return false;
                    }
                    if (state === 'ready') {
                        uploader.upload();
                        // upload.set_upload_param(uploader, true);
                    } else if (state === 'paused') {
                        uploader.upload();
                    } else if (state === 'uploading') {
                        uploader.stop();
                    }
                });
            } else {
                if ($(this).hasClass('disabled')) {
                    return false;
                }
                if (state === 'ready') {
                    uploader.upload();
                    // upload.set_upload_param(uploader, true);
                } else if (state === 'paused') {
                    uploader.upload();
                } else if (state === 'uploading') {
                    uploader.stop();
                }
            }
        });
        // 重新上传
        $info.on('click', '.retry', function () {
            uploader.retry();
        });
        // 忽略文件
        $info.on('click', '.ignore', function () {
            // 循环所有上传失败的文件，将掉过文件上传，直接标记指定文件为已上传状态
            var fileArr = uploader.getFiles('error');
            for (var i = 0; i < fileArr.length; i++) {
                uploader.skipFile(fileArr[i]);
            }
            $('#filePicker2').removeClass('element-invisible');
            $upload.removeClass('disabled');
        });
        $upload.addClass('state-' + state);
        updateTotalProgress();
    });
};

/**
 * 关闭窗口时清空上传队列
 */
function closeUploader () {
    for (var i = 0; i < uploader.getFiles().length; i++) {
        uploader.removeFile(uploader.getFiles()[i]);
    }
    uploader.destroy();
}

export {
    WebUploadInit,
    closeUploader,
}
